import React from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ContactsHeaderProps {
  onNewContact: () => void;
}

export const ContactsHeader = ({ onNewContact }: ContactsHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-2xl font-bold">Contatos</h1>
      <Button onClick={onNewContact}>
        <Plus className="mr-2 h-4 w-4" />
        Novo Contato
      </Button>
    </div>
  );
};